import { render, staticRenderFns } from "./QuestionHeader.vue?vue&type=template&id=d3c9f832&scoped=true"
import script from "./QuestionHeader.vue?vue&type=script&lang=js"
export * from "./QuestionHeader.vue?vue&type=script&lang=js"
import style0 from "./QuestionHeader.vue?vue&type=style&index=0&id=d3c9f832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c9f832",
  null
  
)

export default component.exports